export default {
  public_vapid_key: 'BLA3JgR9oIyJxrM_VlErMmBzyKIZito6Q0n1wVtLAX6_ewpAkfpcLZ_xyBRk3xvtGASxG5S1Jj5hI2MMQdOfI5M',
  config: {
    apiKey: 'AIzaSyBXu2_k7QBpkK0BzxSu80cvhFgGMLQgO8M',
    authDomain: 'suitup-finance.firebaseapp.com',
    databaseURL: 'https://suitup-finance.firebaseio.com',
    projectId: 'suitup-finance',
    storageBucket: '',
    messagingSenderId: '171055119110',
    appId: '1:171055119110:web:07ce3c055336ac7b65bc87'
  }
}
